import type { BadgeColor } from '@civilgrid/ui/components';

// Derive from Badge so the chip's color set can't drift from the component's.
export type ChipVariant = BadgeColor;

// Electric / Gas / Water are confirmed against Figma "Metadata June 2026 Update" (node 115:4045).
// Sewer / Telco follow the utility-locating convention (cf. AssetType.tsx).
// Recycled Water is purple (811/APWA reclaimed-water color; matches AssetType.tsx).
// Storm is green (Seth: Storm & Sewer are both green in the 811 color convention).
const VARIANTS: Record<string, ChipVariant> = {
  Electric: 'red',
  Gas: 'yellow',
  'Oil & Gas': 'yellow',
  Water: 'blue',
  'Recycled Water': 'purple',
  Sewer: 'green',
  Storm: 'green',
  Telco: 'orange',
};

export function categoryChipVariant(label: string | null): ChipVariant {
  if (!label) return 'grey';
  return VARIANTS[label] ?? 'grey';
}
